import { render, staticRenderFns } from "./FenomenShareForm.vue?vue&type=template&id=981ef472&scoped=true"
import script from "./FenomenShareForm.vue?vue&type=script&lang=js"
export * from "./FenomenShareForm.vue?vue&type=script&lang=js"
import style0 from "./FenomenShareForm.vue?vue&type=style&index=0&id=981ef472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981ef472",
  null
  
)

export default component.exports